import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { Field, FieldArray } from "redux-form";
import { Button, Alert } from "reactstrap";
import { phoneNumberValidate } from "../helpers";
import { Loader, FormField } from "pickups-ui-library";

// Validation
const validate = (values) => {
  const errors = {};

  if (!values.phoneNumber) {
    errors.phoneNumber = "Required";
  }

  if (!values.password) {
    errors.password = "Required";
  }

  return errors;
};

const PhoneNumberLookup = (props) => {
  const {
    handleSubmit,
    pristine,
    invalid,
    submitting,
    error,
    addDonor,
    phoneNumber,
    message,
    codeSent,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="phoneNumber"
        type="phone"
        component={FormField}
        label="Phone Number"
        placeholder=""
        validate={[phoneNumberValidate]}
      />
      {error && <Alert color={"danger"}>{error}</Alert>}
      <Button type="submit" disabled={pristine || submitting || error} block>
        {" "}
        {submitting ? <Loader color="#fff" /> : "Send Code"}{" "}
      </Button>
    </form>
  );
};

export default reduxForm({ form: "publicLoginForm", validate })(
  PhoneNumberLookup
);
